import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { analyticsTrack } from '../../../analyticsUtils';

class DropdownList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: props.isExpanded,
    };

    this.expand = this.expand.bind(this);
  }

  expand() {
    const { location, title } = this.props;
    this.setState({ isExpanded: !this.state.isExpanded });
    analyticsTrack('Clicked on dropdown', {
      location,
      content: title,
    });
  }

  render() {
    const {
      title, children, dropdownClass, titleClass, isSideBySide, icon, extraTitleNode,
    } = this.props;
    const { isExpanded } = this.state;

    return (
      <div className="dropdown">
        <div
          role="link"
          tabIndex={0}
          className={`expand-link ${dropdownClass}`}
          onClick={() => this.expand()}
        >
          <div className={`expand-link-container g-row--always ${isSideBySide ? '' : 'g-row--between'}`}>
            <a className={`expand-link ${titleClass} ${isExpanded && 'expanded'}`}>
              {title}
            </a>
            <i className={`fa ${isExpanded ? `fa-${icon}-up` : `fa-${icon}-down`} ms-2`} />
            {extraTitleNode}
          </div>
        </div>
        <div className={`${isExpanded ? 'show' : 'hide'}`}>
          {children}
        </div>
      </div>
    );
  }
}

DropdownList.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  isExpanded: PropTypes.bool,
  titleClass: PropTypes.string,
  dropdownClass: PropTypes.string,
  location: PropTypes.string,
  isSideBySide: PropTypes.bool,
  icon: PropTypes.string,
  extraTitleNode: PropTypes.node,
};

DropdownList.defaultProps = {
  isExpanded: true,
  dropdownClass: '',
  titleClass: '',
  location: '',
  isSideBySide: false,
  icon: 'chevron',
  extraTitleNode: null,
};

export default DropdownList;
